const _ = require('lodash');
const assert = require('assert');

const createDyzioEvent = ({
  message,
  organisationId,
  campaignId,
  messageData,
  jsonAPIClient,
}) => {
  const dyzioevent = jsonAPIClient.create('dyzioevents');
  assert.ok(organisationId);
  assert.ok(campaignId);
  assert.ok(message);
  const attributes = {
    message,
    messageData: messageData || {},
    campaign: {
      type: 'campaigns',
      id: campaignId,
    },
    organisation: {
      type: 'organisations',
      id: organisationId,
    },
    source: 'dyzio-web',
    createdBy: 'dyzio',
    createdDate: new Date(),
  };

  _.forEach(attributes, (value, key) => {
    if (value) {
      dyzioevent.set(key, value);
    }
  });

  return dyzioevent.sync();
};

module.exports = {
  createDyzioEvent,
};



/** WEBPACK FOOTER **
 ** ./src/utils/dyzioevents.js
 **/